import { Loader } from "@joonapp/web-shared"
import { useQueryClient } from "@tanstack/react-query"
import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { analyticsUserDidLogout } from "./analytics"
import { sessionManager } from "./storage"
import { useUserQuery } from "../networking/user/queries"

export const useAuth = () => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  function signout() {
    analyticsUserDidLogout()
    sessionManager.clearAuthTokens()
    navigate("/auth/signin")
    queryClient.removeQueries()
  }

  return { signout }
}

export const requireAuth = (Component: React.FC) => (props: any) => {
  const { status: userStatus } = useUserQuery()
  const navigate = useNavigate()

  useEffect(() => {
    const hasRefreshToken = sessionManager.getRefreshToken()
    if (!hasRefreshToken) return navigate("/auth/signin")
  }, [navigate])

  if ([userStatus].includes("loading")) return <Loader />

  return <Component {...props} />
}
